// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { RoleType } from './roleType.js';
import type { SiteSharedAddressUpsearchModel } from './siteSharedAddressUpsearchModel.js';
import type { SiteSharedEmailAddressUpsearchModel } from './siteSharedEmailAddressUpsearchModel.js';
import type { SiteSharedPhoneUpsearchModel } from './siteSharedPhoneUpsearchModel.js';
import type { SiteSharedWebAddressUpsearchModel } from './siteSharedWebAddressUpsearchModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class SiteSharedContactUpsearchModel {
    'addresses'?: Array<SiteSharedAddressUpsearchModel>;
    'emailAddresses'?: Array<SiteSharedEmailAddressUpsearchModel>;
    'phoneNumbers'?: Array<SiteSharedPhoneUpsearchModel>;
    'webAddresses'?: Array<SiteSharedWebAddressUpsearchModel>;
    'contactId'?: number;
    'contactType'?: RoleType;
    'firstName'?: string;
    'lastName'?: string;
    'occupationDescription'?: string;
    'isMainContact'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof SiteSharedContactUpsearchModel>> = [
        {
            "name":     "addresses",
            "baseName": "addresses",
            "type":     "Array<SiteSharedAddressUpsearchModel>"
        },
        {
            "name":     "emailAddresses",
            "baseName": "emailAddresses",
            "type":     "Array<SiteSharedEmailAddressUpsearchModel>"
        },
        {
            "name":     "phoneNumbers",
            "baseName": "phoneNumbers",
            "type":     "Array<SiteSharedPhoneUpsearchModel>"
        },
        {
            "name":     "webAddresses",
            "baseName": "webAddresses",
            "type":     "Array<SiteSharedWebAddressUpsearchModel>"
        },
        {
            "name":     "contactId",
            "baseName": "contactId",
            "type":     "number"
        },
        {
            "name":     "contactType",
            "baseName": "contactType",
            "type":     "RoleType"
        },
        {
            "name":     "firstName",
            "baseName": "firstName",
            "type":     "string"
        },
        {
            "name":     "lastName",
            "baseName": "lastName",
            "type":     "string"
        },
        {
            "name":     "occupationDescription",
            "baseName": "occupationDescription",
            "type":     "string"
        },
        {
            "name":     "isMainContact",
            "baseName": "isMainContact",
            "type":     "boolean"
        },
    ];

    static getAttributeTypeMap() {
        return SiteSharedContactUpsearchModel.attributeTypeMap;
    }
}
